




















import { Component, Vue, Watch} from 'vue-property-decorator';	
import { Route } from 'vue-router';
import moment from 'moment-timezone'

import { namespace } from "vuex-class";   
import "@/store/modules/common";
import { userInfoType } from "@/types/Admin";
const commonState = namespace("Common");

@Component
export default class MenuBar extends Vue {
	
	@commonState.State
    public user!: userInfoType;

	@commonState.State
    public currentDate!: string;

	@commonState.Action
    public UpdateCurrentDate!: (string) => void;

	bgClass={}

	adminTab = false;
	update=0;

	updateTime=0;
	
	bothGroup=[
		{name:'manage-bookings', label:'Manage Bookings', super_admin:false},
		{name:'add-bookings', label:'Add Bookings', super_admin:false},
	]
	

	@Watch('$route', { immediate: true, deep: true })
	onUrlChange(newVal: Route) {			
		this.ChangeClass(newVal.name)
		this.update++;			
	}

	@Watch('currentDate')
    monthChange(newValue){
        this.updateTime++;
    }

	mounted(){
		this.UpdateCurrentDate(moment().format("ddd MMM DD, YYYY HH:mm"))
	}

	ChangeClass(type){
		const items = this.bothGroup
		for(const item of items)
			this.bgClass[item.name]=""
		
		this.bgClass[type]="bg-cyan"
	}

}
